import { InjectionToken } from '@angular/core';

export const NOTIFICATIONS_API_BASE_URL = new InjectionToken<string>('NOTIFICATIONS_API_BASE_URL');
